'use client';

import Link from 'next/link';
import { Search, Home, ArrowLeft } from 'lucide-react';

export default function NotFound() {
  return (
    <div className="min-h-screen bg-gray-50 flex flex-col justify-center py-12 sm:px-6 lg:px-8">
      <div className="sm:mx-auto sm:w-full sm:max-w-md">
        <div className="bg-white py-8 px-4 shadow sm:rounded-lg sm:px-10">
          {/* 404 Number */}
          <div className="text-center">
            <h1 className="text-6xl font-bold text-blue-600">404</h1>
          </div>
          
          {/* Error Title */}
          <div className="mt-6 text-center">
            <h2 className="text-2xl font-bold text-gray-900">
              找不到頁面
            </h2>
            <p className="mt-2 text-sm text-gray-600">
              抱歉，您要查找的頁面不存在或已被移除。
            </p>
          </div>
          
          {/* Action Buttons */}
          <div className="mt-8 flex flex-col space-y-3">
            <Link
              href="/"
              className="w-full inline-flex items-center justify-center px-4 py-2 border border-transparent text-sm font-medium rounded-md text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
            >
              <Home className="mr-2 h-4 w-4" />
              返回首頁
            </Link>
            
            <Link
              href="/used-cars"
              className="w-full inline-flex items-center justify-center px-4 py-2 border border-gray-300 text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
            >
              <Search className="mr-2 h-4 w-4" />
              瀏覽二手車
            </Link>
            
            <button
              onClick={() => window.history.back()}
              className="w-full inline-flex items-center justify-center px-4 py-2 border border-gray-300 text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
            >
              <ArrowLeft className="mr-2 h-4 w-4" />
              返回上一頁
            </button>
          </div>
          
          {/* Quick Links */}
          <div className="mt-8 text-center">
            <p className="text-sm text-gray-500 mb-4">您可能在尋找：</p>
            <div className="grid grid-cols-2 gap-2 text-xs">
              <Link href="/about" className="text-blue-600 hover:text-blue-500">
                關於我們
              </Link>
              <Link href="/help" className="text-blue-600 hover:text-blue-500">
                幫助中心
              </Link>
              <Link href="/services" className="text-blue-600 hover:text-blue-500">
                服務項目
              </Link>
              <Link href="/contact" className="text-blue-600 hover:text-blue-500">
                聯絡我們
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}